// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1gmVF","row":"Node_row___Lmtb","label":"Node_label__2xSH1","footer":"Node_footer__1EZrt"};